export default {
    es:{
        title: 'SafeTaxi Servicios Moviles SA de CV, declara:',
        parrafos: [
            {
                type: 'title', 
                title: 'Sobre el uso de los servicios de ubicación del dispositivo:',
                text: 'La aplicación SafeTaxi fue diseñada con el objetivo de proporcionar una opción de seguridad a los usuarios que toman un viaje en taxi. Para este propósito el usuario decide cuando compartir un viaje a uno o más de sus contactos (máximo 15) y que estos puedan seguir su viaje en tiempo real.'
            },
            {
                type: 'normal', 
                title: 'El uso de la ubicación en primer plano, ',
                text: 'es durante todo el tiempo que la aplicación esta visible en el teléfono una vez que el usuario decidió compartir un viaje e inicio el servicio.'
            },
            {
                type: 'normal', 
                title: 'El uso de la ubicación en segundo plano, ',
                text: 'entra en acción una vez que el usuario bloquea se dispositivo o cambia de aplicación por alguna razón. En este punto es totalmente necesario acceder a la ubicación en segundo plano por la seguridad del usuario. Es la única forma en que podemos garantizar el servicio ofrecido y el propósito principal de la aplicación.'
            },
            {
                type: 'normal', 
                title: 'El término de acceso a la ubicación termina de forma definitiva una vez que el usuario termina un viaje. ',
                text: 'De esta forma no se implica su localización en ningún momento diferente al viaje que el usuario por propia seguridad ha decidido compartir a los usuarios que él decide. Se puede navegar libremente por la aplicación y todas las opciones sin necesidad de acceder a la ubicación del dispositivo, a menos como ya se mencionó durante un viaje en taxi.'
            },
            {
                type: 'title',
                title: 'Permiso de Almacenamiento',
                text: 'Safetaxi requiere acceso al almacenamiento debido a que guardaremos los ultimos usuarios que ha registrado.'
            },
            {
                type: 'title',
                title: 'Permiso de Imagenes',
                text: 'SafeTaxi requiere acceso a la galeria de imagenes unicamente en el cambio de imagen del perfil.'
            },
            {
                type: 'title',
                title: 'Permiso de Contactos',
                text: 'Safetaxi requiere acceso a tus contactos para poder notificar a estos un viaje que has decidido compartir con el contacto indicado.'
            }
        ]
    },
    en:{
        title: 'SafeTaxi Servicios Moviles SA de CV, declares:',
        parrafos: [
            {
                type: 'title', 
                title: "About the use of the device's location services:",
                text: 'The SafeTaxi application was designed with the goal of providing a safety option to users taking a taxi ride. For this purpose, the user decides when to share a trip to one or more of his contacts (maximum 15) and that they can follow his trip in real time.'
            },
            {
                type: 'normal', 
                title: "The use of the location in the foreground ",
                text: 'is the entire time that the application is visible on the phone once the user decided to share a trip and start the service.'
            },
            {
                type: 'normal', 
                title: "The use of location in the background ",
                text: "kicks in once the user locks their device or switches applications for some reason. At this point it is absolutely necessary to access the location in the background for the user's safety. It is the only way we can guarantee the service offered and the main purpose of the application."
            },
            {
                type: 'normal', 
                title: "The term of access to the location ends definitively once the user finishes a trip. ",
                text: "In this way, its location is not implied at any time other than the trip that the user for his own safety has decided to share with the users he decides. You can freely navigate the application and all the options without having to access the location of the device, unless as already mentioned during a taxi trip."
            },
            {
                type: 'title', 
                title: "Storage Permission",
                text: "Safetaxi requires access to storage because we will save the last users you have registered."
            },
            {
                type: 'title', 
                title: "Image Permission",
                text: "SafeTaxi requires access to the image gallery only in the profile makeover."
            },
            {
                type: 'title', 
                title: "Contact Permission",
                text: "Safetaxi requires access to your contacts in order to notify them of a trip that you have decided to share with the indicated contact."
            },
        ]
    }
}